import { PinDropOutlined } from "@mui/icons-material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonDefault, { ButtonVariant } from "~/src/components/Button/ButtonDefault";
import Text, { TextVariant } from "~/src/components/Text/Text";
import { useFormDataContext } from "~/src/contexts/FormDataContext/FormDataContext";
import { IndividFormDataContext } from "~/src/pages/Registrering/components/IndividForm";
import { AccordionDefault } from "../../../components/Accordion/AccordionDefault";
import Input from "../../../components/Form/Input/Input";

export default function StedfestFelling(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { formData, formErrors, setFormData } = useFormDataContext(IndividFormDataContext);
  const { Merknad, Fellingssted } = formData;
  useEffect(() => {
    if (location.state?.nord && location.state?.ost) {
      setFormData({
        ...formData,
        KoordinatØst: location.state?.ost,
        KoordinatNord: location.state?.nord,
        Koordinatfesting: location.state?.koordinatfesting,
      });
    }
  }, [location.state]);

  const setMerknad = (merknad: string) => setFormData({ ...formData, Merknad: merknad });
  const setFellingssted = (fellingsted: string) =>
    setFormData({ ...formData, Fellingssted: fellingsted });

  return (
    <div>
      <AccordionDefault
        title={t("pages.registrerArt.stedfestFelling.title")}
        defaultOpen
        error={
          formErrors?.Koordinatfesting ||
          formErrors?.KoordinatØst ||
          formErrors?.KoordinatNord ||
          formErrors?.Fellingssted
            ? true
            : false
        }
      >
        <Input
          id="input-fellingssted"
          label={t("pages.registrerArt.stedfestFelling.fellingssted")}
          defaultValue={Fellingssted ?? ""}
          onChange={(e) => setFellingssted(e.target.value)}
          errorMessage={formErrors?.Fellingssted}
          maxLength={200}
        />
        <div
          className={`mt-4 
            ${
              formErrors?.Koordinatfesting || formErrors?.KoordinatØst || formErrors?.KoordinatNord
                ? "bg-ldir-red-700 p-4"
                : ""
            } `}
        >
          <ButtonDefault
            id="stedfest"
            label={t("pages.registrerArt.stedfestFelling.stedfestIKart")}
            onClick={() =>
              navigate("../kart", {
                state: {
                  referrer: location.pathname,
                  nord: formData.KoordinatNord,
                  ost: formData.KoordinatØst,
                  koordinatfesting: formData.Koordinatfesting,
                },
              })
            }
            icon={<PinDropOutlined />}
          />
          {formData.KoordinatNord && formData.KoordinatØst && (
            <>
              {!(
                formErrors?.Koordinatfesting ||
                formErrors?.KoordinatØst ||
                formErrors?.KoordinatNord
              ) && (
                <div className="bg-ldir-green-800 py-6 px-4 mt-4">
                  <div className="flex flex-col items-center">
                    <div className="shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="32"
                        viewBox="0 0 26 32"
                        fill="none"
                        role="graphics-symbol"
                      >
                        <path
                          d="M11.2937 18.16L19.3375 10.24L17.0219 7.96L11.2937 13.6L9.01875 11.36L6.70312 13.64L11.2937 18.16ZM13 32C8.63958 28.3467 5.38281 24.9533 3.22969 21.82C1.07656 18.6867 0 15.7867 0 13.12C0 9.12 1.30677 5.93333 3.92031 3.56C6.53385 1.18667 9.56042 0 13 0C16.4396 0 19.4661 1.18667 22.0797 3.56C24.6932 5.93333 26 9.12 26 13.12C26 15.7867 24.9234 18.6867 22.7703 21.82C20.6172 24.9533 17.3604 28.3467 13 32Z"
                          fill="#4D907D"
                        />
                      </svg>
                    </div>
                    <Text variant={TextVariant.large} className="text-ldir-brown-900 mt-4 mx-6">
                      {t("pages.registrerArt.stedfestFelling.stedfestetIKart")}
                    </Text>
                  </div>
                  <ButtonDefault
                    className="mt-6"
                    id="remove-coordinates"
                    label={t("pages.registrerArt.stedfestFelling.fjernStedfestingskoordinater")}
                    variant={ButtonVariant.Primary}
                    onClick={() =>
                      setFormData({
                        ...formData,
                        KoordinatNord: undefined,
                        KoordinatØst: undefined,
                        Koordinatfesting: undefined,
                      })
                    }
                  />
                </div>
              )}
              <Input
                id="input-koordinatfesting"
                type={"hidden"}
                hidden={true}
                errorMessage={formErrors?.Koordinatfesting}
              />
              <Input
                id="input-koordinatOst"
                type={"hidden"}
                hidden={true}
                errorMessage={formErrors?.KoordinatØst}
              />
              <Input
                id="input-koordinatNord"
                type={"hidden"}
                hidden={true}
                errorMessage={formErrors?.KoordinatNord}
              />
            </>
          )}
        </div>
      </AccordionDefault>
      <AccordionDefault
        title={t("pages.registrerArt.merknad.title")}
        defaultOpen={false}
        info={t("pages.registrerArt.merknad.merknadHelperText")}
      >
        <Input
          id="input-fellingssted-merknad"
          label={t("pages.registrerArt.merknad.merknad")}
          defaultValue={Merknad ?? ""}
          onChange={(e) => setMerknad(e.target.value)}
          errorMessage={formErrors?.Merknad}
          maxLength={2000}
          textArea={true}
        />
      </AccordionDefault>
    </div>
  );
}
